import React, { type ComponentType } from 'react';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import ProjectDirectoriesApp from '@atlassian/jira-project-directories-components/src/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import Components from './view.tsx';

const Updater: ComponentType<{}> = () => <SubProductUpdater subProduct="platform" />;

export default withInjectedProps(Components, {
	ProjectDirectoriesApp,
	Updater,
});
